import React from "react";
import { BookedCourtsResponse } from "../../../apis/types";
import { Colors } from "../../../utils/colors";
import { useMatchListStore } from "../../../stores/StoreContext";
import { Button } from "../../../components/button/Button";
import { TCText } from "../../../components/TCText/TCText";
import { MatchHeader } from "./MatchHeader";
import { MatchDateAndTime } from "./MatchDateAndTime";
import { MatchPlayers } from "./MatchPlayers";

type props = {
  match: BookedCourtsResponse;
  index: number;
};

export const MatchCard: React.FC<props> = ({ match, index }) => {
  const matchListStore = useMatchListStore();

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 16,
        boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
        margin: "16px 16px 0 16px",
        display: "flex",
        flexDirection: "column",
      }}>
      <div
        style={{
          padding: 16,
          display: "flex",
          flexDirection: "column",
          gap: 4,
        }}>
        <MatchHeader match={match} index={index} />
        <hr
          style={{ border: 0, borderTop: "1px solid #eee", margin: "8px 0" }}
        />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}>
          <MatchDateAndTime match={match} />
          <MatchPlayers match={match} />
        </div>
        {!match.cancelIsFree && match.cancellationDescription && (
          <div>
            <TCText
              value={match.cancellationDescription ?? ""}
              style={{ color: Colors.grey, fontSize: 12 }}
            />
          </div>
        )}
      </div>

      {match.canCancel && (
        <Button
          btnStyle={{
            backgroundColor: Colors.darkBrown,
            width: "100%",
            borderRadius: "0 0 16px 16px",
            alignSelf: "center",
          }}
          textStyle={{ color: Colors.white }}
          text={match.isHost ? "Cancel Booking" : "Drop From Match"}
          onPress={() => {
            matchListStore.confirmForDeleteDropBooking(
              match.bookingId,
              match.cancellationDescription,
              match.isHost ?? false
            );
          }}
        />
      )}
    </div>
  );
};
